// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Error_wrapper__f4eT_","main":"Error_main__KJO6_","content":"Error_content___bpFk","illustration":"Error_illustration__AMate","errorId":"Error_errorId__Ht0Oq"};